import { MatchMode } from '../../types/types';
import { isValuelessMatchMode } from './isValuelessMatchMode';

// Valueless match modes are submitted with a boolean sentinel value, so a boolean left over from them is never user input.
export const shouldDropFilterValueOnMatchModeChange = (
  previousMatchMode: MatchMode | undefined,
  nextMatchMode: MatchMode | undefined,
  value: unknown
): boolean => {
  if (typeof value !== 'boolean') return false;
  if (!previousMatchMode || !nextMatchMode) return false;
  if (!isValuelessMatchMode(previousMatchMode)) return false;
  return !isValuelessMatchMode(nextMatchMode);
};
